import { Authority } from 'platform/app/authority.constant';

export const ADVERTORIAL = {
    name: 'Advertorial',
    path: '/advertorial',
    icon: 'dm-image',
    requiresAuthority: Authority.ROLE_ADVERTORIALS_VIEW_EDIT,
};
